export class LabelItem {
    id: number;
    name: string;
    checked: boolean = false;
    color: string = "green-500";
    editing: boolean = false;
    passwords: number = 0;
}